<template>
  <div>
    <div class="row">
      <div class="col-sm-2">
        <div>
          <img :src="'/images/bannerlayout.png'" alt="" />
        </div>
      </div>
      <div class="col-sm-10">
        <div>
          <h2 style="font-weight: 600; margin-bottom: 0.5rem !important">
            Company Info
          </h2>
          <small style="font-size: 80% !important"
            >Choose an image that will be displayed at the top of your
            page</small
          >
        </div>
      </div>
    </div>
    <form action="" class="mt-4">
      <div class="form-row">
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("company_name") }}</label>
          <app-input type="text" :required="true" v-model="inputs.company_name" :read-only="inputType"/>
        </div>
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("company_number") }}</label>
          <app-input type="text" :required="true" v-model="inputs.comapny_number" :read-only="inputType"/>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("address_line_1") }}</label>
          <app-input type="text" :required="true" v-model="info.address_line_1" :read-only="inputType"/>
        </div>
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("address_line_2") }}</label>
          <app-input type="text" :required="true" v-model="info.address_line_2" :read-only="inputType" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-4">
          <label for="user_first_name">{{ $t("email") }}</label>
          <app-input type="email" :required="true" v-model="inputs.company_email" :read-only="inputType"/>
        </div>
        <div class="form-group col-4">
          <label for="user_first_name">{{ $t("country") }}</label>
          <app-input type="text" :required="true" v-model="inputs.country" :read-only="inputType"/>
        </div>
        <div class="form-group col-4">
          <label for="user_company_phone_number">{{ $t("Company Phone") }}</label>
          <app-input type="number" :required="true" v-model="inputs.company_phone" :read-only="inputType"/>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("locality") }}</label>
          <app-input type="text" :required="true" v-model="inputs.city" :read-only="inputType"/>
        </div>
        <div class="form-group col-6">
          <label for="user_first_name">{{ $t("postal_code") }}</label>
          <app-input type="text" :required="true" v-model="inputs.postal_code" :read-only="inputType"/>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-6">
          <label for="status">{{ $t("Status") }}</label>
          <app-input type="text" :disabled="true"  v-model="inputs.status" :read-only="inputType"/>
        </div>
        <div class="form-group col-6">
          <label for="address">{{ $t("address") }}</label>
          <app-input type="textarea" :read-only="true" v-model="inputs.address"/>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-6">
          <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <app-input
                      type="single-checkbox"
                      :list-value-field="$t('non_uk_company')"
                      v-model="otherDetail.non_uk_company"
                    />
                  </div>
                </div>
              </div>
        </div>
        <div class="form-group col-6">
          <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label for="co_registration_number">{{ $t("co_registration_number") }}</label>
                    <app-input type="number" v-model="otherDetail.co_registration_number" :read-only="inputType"/>
                  </div>
                </div>
              </div>
        </div>
         <div class="form-group col-6">
          <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label for="vat_number">{{ $t("vat_number") }}</label>
                    <app-input type="number" v-model="otherDetail.vat_number" :read-only="inputType"/>
                  </div>
                </div>
              </div>
        </div>
        <div class="form-group col-6">
          <div class="form-group row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <label for="duns_number">{{ $t("duns_number") }}</label>
                <app-input type="number" v-model="otherDetail.duns_number" :read-only="inputType"/>
              </div>
            </div>
          </div>
       </div>
        <div class="form-group col-6">
          <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label for="sme_status">{{ $t("sme_status") }}</label>
                    <app-input
                      type="select"
                      :placeholder="$t('status')"
                      :list="sme_status"
                      v-model="otherDetail.sme_status"
                    />
                  </div>
                </div>
              </div>
        </div>
        <div class="form-group col-6">
          <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label for="last_submitted_by_vendor">{{ $t("last_submitted_by_vendor") }}</label>
                    <app-input type="text" v-model="otherDetail.last_submitted_by_vendor" :read-only="inputType"/>
                  </div>
                </div>
              </div>
        </div>
        <div class="form-group col-6">
          <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label for="environment_policy">{{ $t("environment_policy") }}</label>
                    <app-input
                      type="select"
                      :placeholder="$t('environment_policy')"
                      :list="status"
                      v-model="otherDetail.environment_policy"
                    />
                  </div>
                </div>
              </div>
        </div>
        <div class="form-group col-6">
          <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <label for="ssip_accredited">{{ $t("ssip_accredited") }}</label>
                    <app-input
                      type="select"
                      :placeholder="$t('ssip_accredited')"
                      :list="status"
                      v-model="otherDetail.ssip_accredited"
                    />
                  </div>
                </div>
              </div>
        </div>
        <div class="form-group col-12">
          <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-12">
              <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <app-input
                      type="single-checkbox"
                      :list-value-field="$t('cmdcoordinator')"
                      v-model="otherDetail.cmdcoordinator"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-12">
              <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <app-input
                      type="single-checkbox"
                      :list-value-field="$t('consultant')"
                      v-model="otherDetail.consultant"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-12">
              <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <app-input
                      type="single-checkbox"
                      :list-value-field="$t('designer')"
                      v-model="otherDetail.designer"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12">
              <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <app-input
                      type="single-checkbox"
                      :list-value-field="$t('subcontractor')"
                      v-model="otherDetail.subcontractor"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-12">
              <div class="form-group row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <app-input
                      type="single-checkbox"
                      :list-value-field="$t('supplier')"
                      v-model="otherDetail.supplier"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h5>UTR</h5>
          </div>
           <div class="form-group col-6">
            <div class="form-group row align-items-center">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group">
                  <label for="utr_number">{{ $t("utr_number") }}</label>
                  <app-input type="number" v-model="otherDetail.utr_number" :read-only="inputType"/>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group col-6">
            <div class="form-group row align-items-center">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group">
                  <label for="name_of_partner">{{ $t("name_of_partner") }}</label>
                  <app-input type="text" v-model="otherDetail.name_of_partner" :read-only="inputType"/>
                </div>
              </div>
            </div>
          </div>
         <div class="form-group col-6">
            <div class="form-group row align-items-center">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group">
                  <label for="partners_utr_number">{{ $t("partners_utr_number") }}</label>
                  <app-input type="number" v-model="otherDetail.partners_utr_number" :read-only="inputType"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </form>
    <div class="d-flex justify-content-end" v-if="userRole.company_id == inputs.id">
         <button type="button" class="btn btn-primary" @click="alertModal">
                    {{ $t('Save changes') }}
         </button>   
    </div>
                <app-modal v-if="setModal"
                           modal-id="alert-modal"
                           modal-alignment="center"
                           modal-size="md"
                           @close-modal="closeModal">
                    <div class="modal-body d-flex flex-column justify-content-center modal-alert">
                        <div class="text-center">
                            <app-icon class="text-warning" :name="'alert-triangle'"/>
                        </div>
                        <h5 class="text-center font-weight-bold mt-4">{{ $t('alert')+'!' }}</h5>
                        <p class="text-center mb-4 font-size-90">{{ $t('Please enter password for verfication') }}</p>
                         <app-input type="password" :required="true" v-model="inputs.password" placeholder="Enter Password"/>
                         <small v-html="message" class="text-danger ml-2"></small>
                        <div class="text-center mt-3">
                            <a href="#" class="btn btn-warning" @click.prevent="updateModal">
                                {{ $t('continue') }}
                            </a>
                        </div>
                    </div>
                </app-modal>
  </div>
</template>
<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { axiosGet, axiosPost } from "../../../../Helpers/AxiosHelper";
import {COMPANY_INO_UPDATE} from "../../../../../app/Config/ApiUrl";

export default {
  mixins: [FormMixin],
  data() {
    return {
      //   readOnly: true,
      inputType: false,
      setModal: false,
      inputs: null,
      info: {},
      otherDetail: null,
      sme_status: [
        {id:'none', value:'None'},
        {id:'micro', value:'Micro'},
        {id:'small', value:'Small'},
        {id:'medium', value:'Medium'},
        {id:'large', value:'Large'}
      ],
      status: [
        {id:'yes', value:'Yes'},
        {id:'no', value:'No'},
      ],
    };
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
  mounted() {
    setTimeout(() => {
      this.inputs = this.$store.state.userCompanyProfile.dataProfile.company;
      this.otherDetail = this.$store.state.userCompanyProfile.dataProfile.company.other_detail ?? {};
    }, 1000);

    var url = window.location.pathname;
    var profileType = url.substring(url.lastIndexOf("/") + 1);
      if(profileType != 'my-profile') {
        this.inputType = true;
      }
  },
  methods: {
    alertModal(){
        this.message = '';
       this.setModal = true
    },
    updateModal(){
      if (this.inputs.password == null) {
          this.message = 'Password Field Is Required';
      }
      else {
          this.info = {
            'company_name': this.inputs.company_name,
            'comapny_number': this.inputs.comapny_number,
            'company_email': this.inputs.company_email,
            'address_line_1': this.info.address_line_1,
            'address_line_2': this.info.address_line_2,
            'company_phone':this.inputs.company_phone,
            'country': this.inputs.country,
            'city': this.inputs.city,
            'postal_code': this.inputs.postal_code,
            'password': this.inputs.password,
          };
          this.info.otherDetail = this.otherDetail;
        axiosPost(COMPANY_INO_UPDATE, this.info)
          .then((res) => {

            if (res.data.message) {
              this.$toastr.s(res.data.message);
            }
            else {
            this.$toastr.w(res.data.info);
            }
            // $('#alert-modal').hide();
            // this.setModal = false;
          })
          .catch((error) => {
            
            this.$toastr.e(error.data.type);
          })
          .finally(() => {
            // location.reload();
            this.preloader = false;
            this.closeModal();
          });
      }
      // this.setModal = false;
    },
    closeModal() {
      this.setModal = false;
    }
  },
};
</script>